import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "d-md-none d-lg-none d-xl-none filter-expand" }, "Filter your search", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "d-none d-md-block filters-title" }, "Narrow Your Choices", -1)
const _hoisted_4 = { class: "filter-wrap" }
const _hoisted_5 = { class: "filter-wrap" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Clear")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "filters-title" }, "Item Condition", -1)
const _hoisted_8 = { class: "filter-wrap" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Clear")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h5", { class: "filters-title" }, "Category", -1)
const _hoisted_11 = { class: "filter-wrap" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Clear")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h5", { class: "filters-title" }, "Manufacturer", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_search_filter = _resolveComponent("v-search-filter")!
  const _component_fa = _resolveComponent("fa")!
  const _component_v_form_checkbox_group = _resolveComponent("v-form-checkbox-group")!
  const _component_v_tree = _resolveComponent("v-tree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_search_filter, {
        onItemsSearch: _ctx.onItemsSearch,
        modelValue: _ctx.keywords,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keywords) = $event)),
        searchKey: "title",
        placeholder: "Search"
      }, null, 8, ["onItemsSearch", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "clear link",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.clearFilter('conditions')), ["prevent"]))
      }, [
        _createVNode(_component_fa, { icon: "times-circle" }),
        _hoisted_6
      ]),
      _hoisted_7,
      _createVNode(_component_v_form_checkbox_group, {
        modelValue: _ctx.selectedConditions,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedConditions) = $event)),
        items: _ctx.conditions,
        onItemsSearch: _ctx.onItemsSearch,
        searchKey: "conditions"
      }, null, 8, ["modelValue", "items", "onItemsSearch"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        class: "clear link",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.clearFilter('categories')), ["prevent"]))
      }, [
        _createVNode(_component_fa, { icon: "times-circle" }),
        _hoisted_9
      ]),
      _hoisted_10,
      _createVNode(_component_v_tree, {
        items: _ctx.categories,
        hasInputSearch: "",
        modelValue: _ctx.selectedCategories,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCategories) = $event)),
        onItemsSearch: _ctx.onItemsSearch,
        searchKey: "categories"
      }, null, 8, ["items", "modelValue", "onItemsSearch"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "clear link",
        onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.clearFilter('manufacturers')), ["prevent"]))
      }, [
        _createVNode(_component_fa, { icon: "times-circle" }),
        _hoisted_12
      ]),
      _hoisted_13,
      _createVNode(_component_v_tree, {
        items: _ctx.manufacturers,
        modelValue: _ctx.selectedManufacturers,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedManufacturers) = $event)),
        onItemsSearch: _ctx.onItemsSearch,
        searchKey: "manufacturers"
      }, null, 8, ["items", "modelValue", "onItemsSearch"])
    ])
  ]))
}